function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}import{REQUEST_ORDER_DETAILS,RECEIVE_ORDER_DETAILS,ERROR_ORDER_DETAILS}from"../constants";/**
 * @typedef {Object} OrderDetailParams
 * @property {number} [params.orderId] Order Id
 * @property {string} [params.orderNumber] Order Number
 * @property {string} [params.email] Email
 * @property {string} [params.phone] Phone Number
 * @property {string} [params.token] Request params
 */ /**
 * Creates the dispatched REQUEST_ORDER_DETAILS action object.
 * @param {OrderDetailParams} params Request params
 * @returns {Object} The dispatched action object.
 */export var requestOrderDetails=function requestOrderDetails(params){return _extends({type:REQUEST_ORDER_DETAILS},params);};/**
 * Creates the dispatched RECEIVE_ORDER_DETAILS action object.
 * @param {OrderDetailParams} params Request params
 * @param {Object} order An order object
 * @returns {Object} The dispatched action object.
 */export var receiveOrderDetails=function receiveOrderDetails(params,order){return _extends({type:RECEIVE_ORDER_DETAILS},params,{order:order});};/**
 * Creates the dispatched ERROR_ORDER_DETAILS action object.
 * @param {Error} error An error object
 * @param {OrderDetailParams} params Request params
 * @returns {Object} The dispatched action object.
 */export var errorOrderDetails=function errorOrderDetails(error,params){return _extends({type:ERROR_ORDER_DETAILS,error:error},params);};